<script setup lang="ts">
import {Plus, Zap} from "@lucide/vue";
import {NotificationTemplate} from "@/notification-template/interfaces";
import TemplatePreview from "@/rcs/components/try-dialog/shared/TemplatePreview.vue";
import CreditBalance from "@/rcs/components/try-dialog/shared/CreditBalance.vue";
import {Button} from "@/core/components/ui/button";
import StepDialogHeader from "@/rcs/components/try-dialog/shared/StepDialogHeader.vue";

defineProps<{
    template: NotificationTemplate;
}>();

defineEmits<{
    (e: 'cancel'): void
}>();
</script>

<template>
  <div class="flex flex-col gap-6">
    <div class="flex flex-col gap-3">
      <StepDialogHeader :icon="Zap" />
      <div class="flex flex-col gap-1">
        <h2 class="text-black">
          Crédits insuffisants
        </h2>
        <p class="text-muted-foreground text-sm">
          Il vous faut {{ template.credits }} crédit{{ template.credits > 1 ? 's' : '' }} pour envoyer ce RCS. Rechargez votre compte pour
          continuer.
        </p>
      </div>
      <TemplatePreview :template="template" />
      <CreditBalance :cost="template.credits" />
      <div class="flex justify-end items-center gap-3">
        <Button variant="outline" @click="$emit('cancel')">
          Plus tard
        </Button>
        <router-link to="/patient-administration/communication/message/store">
          <Button class="bg-primary">
            <Plus /> Recharger mes crédits
          </Button>
        </router-link>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
